import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import App from "./App";
import "./styles/base.css";
import "./styles/shell.css";
import "./styles/login.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root aplikasi JosephCare tidak ditemui.");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if (import.meta.env.PROD && !Capacitor.isNativePlatform() && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {
      // The prototype remains usable as a normal web app if PWA registration fails.
    });
  });
}

